import { auth } from "../../../db.js";
import firebase from "firebase/app";

export const updateBetaFeatures = ({ form, store }) => {
    form.setValues({
        showBetaFeatures: store.state.user?.Basic?.showBetaFeatures === true,
    });
    form.setConfig({
        "title": "Show Beta Features",
        "type": "update",
        "location": `Userdata/${store.getters.userID}/Basic`,
        "successMessage": "Beta features updated",
        "description": "<p>Turn this on to try features that are still in progress. Help Chat is included.</p>",
        "fields": [{
            "name": "showBetaFeatures",
            "label": "Show beta features",
            "type": "toggle",
            "required": false,
        }],
    });
    form.toggle();
};

export const updatePassword = ({ form }) => {
    form.setConfig({
        "title": "Update Password",
        "type": "ignoreAutoAction",
        "successMessage": "Password updated successfully",
        "fields": [{
            "label": "Current Password",
            "name": "currentPassword",
            "type": "password"
        }, {
            "label": "New Password",
            "name": "newPassword",
            "type": "password"
        }, {
            "label": "Confirm New Password",
            "name": "confirmPassword",
            "type": "password"
        }],
        async preSubmitHook({ data }) {
            if (data.newPassword !== data.confirmPassword) {
                throw new Error("New passwords do not match");
            }
            const credential = firebase.auth.EmailAuthProvider.credential(
                auth.currentUser.email,
                data.currentPassword
            );
            await auth.currentUser.reauthenticateWithCredential(credential);
            await auth.currentUser.updatePassword(data.newPassword);
        }
    });
    form.toggle();
};

export const addSignature = ({ form, store }) => {
    form.setConfig({
        "title": "Add Signature",
        "type": "update",
        "location": `Userdata/${store.getters.userID}/Signature`,
        "successMessage": "Signature uploaded successfully",
        // TODO: Replace href with the actual third-party signature creation service URL
        "description": `<p>Drop an image of your signature, or paste one from the clipboard. You can also <a class="text-primary underline" href="https://signaturely.com/online-signature/draw/" target="_blank" rel="noopener noreferrer">create one online</a>.</p>`,
        "fields": [{
            "label": "Signature",
            "name": "file",
            "type": "fileDragDrop",
            "accept": "image/png,image/jpeg,.svg",
            "divClass": "md:col-span-3"
        }],
        preSubmitHook({ files }) {
            if (!files[0]?.[0]) {
                throw new Error("Please select a file");
            }

            return {
                file: files[0][0].name
            }
        },
        async postSubmitHook({ files, db }) {
            const uid = store.getters.userID;
            if (!files[0]?.[0]) throw new Error("Please select a file");
            await db.upload(`Userdata/${uid}/Signature`, files[0][0]);
        }
    });
    form.toggle();
};
